import { inject, observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';

import Box from '@mui/material/Box';

import useStores from 'app/main/hooks/use-stores';

import { WidgetBulletins, WidgetEntriesPerDay, WidgetExploits, WidgetVendors } from '../../../stats/total/Widgets';

const useStyles = makeStyles()({
    root: {
        padding: 100,
        paddingTop: 24,
        overflowX: 'scroll',
        background: '#fff',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        '@media (max-width: 1140px)': {
            padding: '60px 20px'
        }
    },
    widgets: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        maxWidth: 1340,
        margin: '0 auto',
        '@media (max-width: 1140px)': {
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            overflowX: 'scroll',
            padding: '0 0 0 20px',
            '&> div': {
                marginRight: 32
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    },
    widgetRoot: {
        minWidth: 214,
        background: '#FDF9F3',
        border: 'none',
        transition: 'all 0.6ms',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: '0px 10px 40px rgba(186, 184, 176, 0.2)'
        }
    },
    widgetValue: {
        fontSize: 36,
        color: '#4d4d4d',
        fontWeight: 700
    }
});

const Widgets = () => {
    const { classes } = useStyles();
    const { statsStore } = useStores();
    useEffect(() => {
        statsStore.loadBulletinStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box className={classes.widgets}>
            <WidgetBulletins classes={{ root: classes.widgetRoot, value: classes.widgetValue }} />
            <WidgetVendors classes={{ root: classes.widgetRoot, value: classes.widgetValue }} />
            <WidgetExploits classes={{ root: classes.widgetRoot, value: classes.widgetValue }} />
            <WidgetEntriesPerDay classes={{ root: classes.widgetRoot, value: classes.widgetValue }} />
            {/*<WidgetCVEPerDay classes={{root: classes.widgetRoot, value: classes.widgetValue}}/>*/}
            {/*<WidgetExploitAppearHours classes={{root: classes.widgetRoot, value: classes.widgetValue}}/>*/}
            {/*<WidgetWildExploited classes={{root: classes.widgetRoot, value: classes.widgetValue}}/>*/}
            {/*<WidgetScore classes={{root: classes.widgetRoot, value: classes.widgetValue}}/>*/}
        </Box>
    );
};

export default inject('statsStore')(observer(Widgets));
